"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-clock-dark.tsx
var ClockDark = function ClockDark(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M10.1999 11.633L11.1333 10.6997L8.66658 8.23301V5.16634H7.33325V8.76634L10.1999 11.633ZM7.99992 15.1663C7.0777 15.1663 6.21103 14.9913 5.39992 14.6413C4.58881 14.2913 3.88325 13.8163 3.28325 13.2163C2.68325 12.6163 2.20825 11.9108 1.85825 11.0997C1.50825 10.2886 1.33325 9.4219 1.33325 8.49967C1.33325 7.57745 1.50825 6.71079 1.85825 5.89967C2.20825 5.08856 2.68325 4.38301 3.28325 3.78301C3.88325 3.18301 4.58881 2.70801 5.39992 2.35801C6.21103 2.00801 7.0777 1.83301 7.99992 1.83301C8.92214 1.83301 9.78881 2.00801 10.5999 2.35801C11.411 2.70801 12.1166 3.18301 12.7166 3.78301C13.3166 4.38301 13.7916 5.08856 14.1416 5.89967C14.4916 6.71079 14.6666 7.57745 14.6666 8.49967C14.6666 9.4219 14.4916 10.2886 14.1416 11.0997C13.7916 11.9108 13.3166 12.6163 12.7166 13.2163C12.1166 13.8163 11.411 14.2913 10.5999 14.6413C9.78881 14.9913 8.92214 15.1663 7.99992 15.1663Z"
  }));
};

var _default = ClockDark;
exports.default = _default;